import * as React from 'react';

const EmptyVoiceMsg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={90} height={90} fill="none">
    <path
      fill="#F9F9F9"
      d="M87.928 17.316a27.858 27.858 0 0 1 2.07 10.801v33.75A27.857 27.857 0 0 1 61.877 89.99H5.637A5.315 5.315 0 0 1 .01 84.363V28.124A27.858 27.858 0 0 1 28.133.001h33.743a27.858 27.858 0 0 1 26.052 17.315Z"
    />
    <mask
      id="a"
      width={90}
      height={90}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path
        fill="#F9F9F9"
        d="M87.928 17.316a27.858 27.858 0 0 1 2.07 10.801v33.75A27.857 27.857 0 0 1 61.877 89.99H5.637A5.315 5.315 0 0 1 .01 84.363V28.124A27.858 27.858 0 0 1 28.133.001h33.743a27.858 27.858 0 0 1 26.052 17.315Z"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#2961FA"
        d="M102.974 58.524h-84.66a9.006 9.006 0 0 1-9.006-9.007V30.26h93.666a9.007 9.007 0 0 1 9.006 9.006v10.252a9.005 9.005 0 0 1-9.006 9.007Z"
        opacity={0.14}
      />
      <path
        fill="#fff"
        d="M20.117 54.02a6.304 6.304 0 1 0 0-12.608 6.304 6.304 0 0 0 0 12.609Z"
      />
      <path
        fill="#2D2756"
        d="M18.221 45.28v4.836a.64.64 0 0 0 .96.63l3.842-2.452a.697.697 0 0 0 0-1.192l-3.841-2.452a.684.684 0 0 0-.96.63Z"
      />
      <g fill="#2961FA" opacity={0.271}>
        <path d="M89.993 53.84a48.614 48.614 0 0 1-.166-2.936c-.03-.979-.045-1.958-.047-2.936-.003-.979.013-1.958.044-2.937.032-.978.078-1.957.167-2.935.09.978.135 1.957.167 2.936.031.979.045 1.957.045 2.936 0 .978-.014 1.957-.047 2.936a52.856 52.856 0 0 1-.163 2.936Z" />
        <path d="M89.566 52.634a31.53 31.53 0 0 1-.168-2.333 59.335 59.335 0 0 1 0-4.666c.031-.778.08-1.556.168-2.334.09.778.135 1.556.168 2.334a60.12 60.12 0 0 1 0 4.666 31.51 31.51 0 0 1-.168 2.333Z" />
        <path d="M89.14 48.832a1.354 1.354 0 0 1-.165-.432 1.925 1.925 0 0 1-.048-.432c-.001-.145.014-.29.045-.432a.248.248 0 1 1 .333 0c.032.142.047.287.045.432 0 .145-.015.29-.047.432a1.349 1.349 0 0 1-.163.432Z" />
        <path d="M88.711 49.247a2.663 2.663 0 0 1-.166-.64 4.172 4.172 0 0 1-.047-.64 4.098 4.098 0 0 1 .045-.639c.028-.219.084-.434.167-.639.082.205.138.42.166.64.032.211.047.425.045.639.001.214-.015.428-.047.64-.027.218-.082.433-.163.639ZM88.287 48.505a.692.692 0 0 1-.165-.27.766.766 0 0 1-.048-.27.754.754 0 0 1 .045-.27.185.185 0 0 1 .076-.246.186.186 0 0 1 .257.246.754.754 0 0 1 .045.27.766.766 0 0 1-.047.27.69.69 0 0 1-.163.27Z" />
        <path d="M87.86 52.355a27.877 27.877 0 0 1-.166-2.194 52.28 52.28 0 0 1 0-4.387c.03-.73.078-1.462.167-2.193.09.731.135 1.462.168 2.193a53.16 53.16 0 0 1 0 4.387c-.03.732-.08 1.462-.168 2.194Z" />
        <path d="M87.433 53.257a40.376 40.376 0 0 1-.167-2.645 76.231 76.231 0 0 1 0-5.29c.03-.88.078-1.762.167-2.644.09.882.135 1.763.168 2.645a77.493 77.493 0 0 1 0 5.29c-.03.881-.08 1.762-.168 2.644Z" />
        <path d="M87.005 52.946c-.09-.83-.135-1.66-.167-2.49a67.538 67.538 0 0 1 0-4.978c.03-.829.078-1.658.168-2.488.09.83.135 1.66.168 2.49a68.64 68.64 0 0 1 0 4.978c-.03.828-.08 1.658-.169 2.488Z" />
        <path d="M86.58 52.594a30.95 30.95 0 0 1-.168-2.313 58.329 58.329 0 0 1 0-4.627c.03-.77.079-1.542.168-2.313.09.77.135 1.542.167 2.313a59.296 59.296 0 0 1 0 4.627c-.03.77-.08 1.542-.168 2.313Z" />
        <path d="M86.153 53.106a38.05 38.05 0 0 1-.167-2.567 71.809 71.809 0 0 1 0-5.134c.031-.855.079-1.71.168-2.566.09.855.135 1.71.168 2.566a73.001 73.001 0 0 1 0 5.134c-.03.856-.08 1.71-.169 2.567Z" />
        <path d="M85.728 52.713a32.62 32.62 0 0 1-.167-2.373 61.385 61.385 0 0 1 0-4.746c.03-.791.078-1.583.167-2.373.09.79.135 1.582.168 2.373a62.203 62.203 0 0 1 0 4.746 32.55 32.55 0 0 1-.168 2.373Z" />
        <path d="M85.3 52.483a29.49 29.49 0 0 1-.167-2.258 55.546 55.546 0 0 1 0-4.515c.03-.752.079-1.504.167-2.257.09.753.136 1.505.168 2.258a56.468 56.468 0 0 1 0 4.515c-.03.752-.08 1.504-.168 2.257Z" />
        <path d="M84.876 52.155a25.41 25.41 0 0 1-.167-2.094 47.816 47.816 0 0 1 0-4.188c.03-.698.079-1.396.168-2.094.09.698.135 1.396.168 2.094a48.565 48.565 0 0 1 0 4.188c-.03.697-.08 1.396-.169 2.094Z" />
        <path d="M84.448 51.788a21.225 21.225 0 0 1-.167-1.91 39.787 39.787 0 0 1 0-3.82c.031-.638.08-1.275.168-1.911.09.636.135 1.273.167 1.91a40.314 40.314 0 0 1 0 3.82 21.19 21.19 0 0 1-.168 1.91Z" />
        <path d="M84.023 50.059a6.857 6.857 0 0 1-.167-1.046 11.91 11.91 0 0 1 0-2.091c.028-.352.084-.702.167-1.046.083.344.14.694.168 1.046a12.187 12.187 0 0 1 0 2.091 6.847 6.847 0 0 1-.168 1.046Z" />
        <path d="M83.595 52.45a29.116 29.116 0 0 1-.167-2.24 52.524 52.524 0 0 1-.045-2.242c0-.747.014-1.495.045-2.242.03-.747.079-1.494.167-2.24.09.746.136 1.493.168 2.24a55.65 55.65 0 0 1 0 4.483c-.03.747-.08 1.494-.168 2.241Z" />
      </g>
      <path
        fill="#2961FA"
        d="M82.999 48.134H29.772a.241.241 0 0 1 0-.48H83a.241.241 0 0 1 0 .48Z"
      />
      <path
        fill="#2961FA"
        d="M82.057 48.852a1.65 1.65 0 0 1-.167-.479 2.502 2.502 0 0 1 0-.958.27.27 0 1 1 .335 0c.03.158.046.318.045.48 0 .16-.015.32-.045.478a1.652 1.652 0 0 1-.168.48Z"
      />
      <path
        fill="#2961FA"
        d="M81.632 49.507a4.183 4.183 0 0 1-.167-.806 7.013 7.013 0 0 1-.045-.807c0-.27.014-.539.045-.806.029-.274.085-.544.167-.807.083.263.14.533.168.806.03.268.046.538.045.807 0 .27-.014.539-.045.807-.03.273-.086.543-.168.806Z"
      />
      <path
        fill="#2961FA"
        d="M81.204 49.842a5.974 5.974 0 0 1-.167-.974 10.375 10.375 0 0 1 0-1.948c.029-.328.085-.654.168-.974.083.32.139.646.167.974a10.547 10.547 0 0 1 0 1.948c-.029.33-.085.655-.168.974Z"
      />
      <path
        fill="#2961FA"
        d="M80.778 50.233a8.544 8.544 0 0 1-.167-1.17 14.963 14.963 0 0 1 0-2.342c.029-.394.085-.785.168-1.171.084.386.14.777.168 1.17a15.272 15.272 0 0 1 0 2.342 8.527 8.527 0 0 1-.169 1.171Z"
      />
      <path
        fill="#2961FA"
        d="M80.35 49.898a6.315 6.315 0 0 1-.166-1.002 10.974 10.974 0 0 1 0-2.004c.028-.338.084-.673.167-1.002.083.329.14.664.168 1.002a11.15 11.15 0 0 1 0 2.004 6.315 6.315 0 0 1-.168 1.002Z"
      />
      <path
        fill="#2961FA"
        d="M79.925 49.627a4.787 4.787 0 0 1-.167-.866 8.08 8.08 0 0 1-.045-.866c0-.29.014-.578.045-.866.029-.293.085-.583.168-.866.082.283.138.573.167.866.03.288.046.577.045.866 0 .29-.014.578-.045.866-.03.293-.086.583-.168.866ZM79.497 49.332a3.38 3.38 0 0 1-.167-.72 5.562 5.562 0 0 1-.045-.721c0-.241.014-.482.045-.72.03-.246.085-.488.168-.721.082.233.138.475.167.72.031.24.046.48.045.72 0 .242-.014.482-.045.721-.03.246-.086.487-.168.72Z"
      />
      <path
        fill="#2961FA"
        d="M79.072 48.852a1.65 1.65 0 0 1-.167-.479 2.494 2.494 0 0 1-.045-.479c0-.16.014-.321.045-.479a.27.27 0 1 1 .336 0c.03.158.045.318.045.48 0 .16-.015.32-.045.478a1.652 1.652 0 0 1-.169.48Z"
      />
      <path
        fill="#2961FA"
        d="M78.644 48.605a1.036 1.036 0 0 1-.167-.355 1.383 1.383 0 0 1-.045-.356c0-.12.014-.239.045-.355a.217.217 0 1 1 .335 0 1.383 1.383 0 0 1 0 .71c-.032.129-.09.25-.168.356Z"
      />
      <path
        fill="#2961FA"
        d="M78.22 48.502a.834.834 0 0 1-.167-.304 1.024 1.024 0 0 1 0-.607.198.198 0 1 1 .335 0 1.02 1.02 0 0 1 0 .607.836.836 0 0 1-.168.303Z"
      />
      <path
        fill="#2961FA"
        d="M77.794 48.502a.833.833 0 0 1-.167-.304 1.024 1.024 0 0 1 0-.607.198.198 0 1 1 .336 0 1.02 1.02 0 0 1 0 .607.837.837 0 0 1-.169.303Z"
      />
      <path
        fill="#2961FA"
        d="M77.366 49.826a5.9 5.9 0 0 1-.167-.966 10.204 10.204 0 0 1 0-1.932c.029-.326.085-.649.168-.966.083.317.14.64.168.966a10.338 10.338 0 0 1 0 1.932c-.03.326-.086.65-.169.966Z"
      />
      <path
        fill="#2961FA"
        d="M76.94 52.273c-.09-.73-.135-1.46-.166-2.19a52.238 52.238 0 0 1 0-4.379c.03-.729.078-1.459.167-2.188.09.73.135 1.46.168 2.19a52.944 52.944 0 0 1 0 4.379c-.03.729-.08 1.459-.168 2.188Z"
      />
      <path
        fill="#2961FA"
        d="M76.513 52.8a34.787 34.787 0 0 1-.167-2.452 65.595 65.595 0 0 1 0-4.906c.03-.818.078-1.636.168-2.453.09.818.135 1.635.167 2.453a66.429 66.429 0 0 1 0 4.906c-.03.817-.079 1.635-.168 2.452Z"
      />
      <path
        fill="#2961FA"
        d="M76.086 53.766a48.616 48.616 0 0 1-.165-2.936c-.031-.978-.046-1.957-.048-2.936-.002-.978.013-1.957.045-2.936.032-.978.078-1.957.167-2.936.09.979.135 1.957.166 2.936.032.979.046 1.958.046 2.936 0 .979-.014 1.957-.048 2.936a53.052 53.052 0 0 1-.163 2.936Z"
      />
      <path
        fill="#2961FA"
        d="M75.66 52.562a31.476 31.476 0 0 1-.168-2.334 59.335 59.335 0 0 1 0-4.666c.03-.778.08-1.555.168-2.333a31.7 31.7 0 0 1 .167 2.333 60.12 60.12 0 0 1 0 4.666c-.03.778-.08 1.556-.168 2.334Z"
      />
      <path
        fill="#2961FA"
        d="M75.234 48.758a1.353 1.353 0 0 1-.166-.432 1.919 1.919 0 0 1-.047-.431c-.002-.146.014-.29.045-.432a.248.248 0 1 1 .333 0c.031.141.046.286.045.432 0 .145-.015.29-.047.431a1.352 1.352 0 0 1-.163.432Z"
      />
      <path
        fill="#2961FA"
        d="M74.807 49.173a2.657 2.657 0 0 1-.166-.64 4.16 4.16 0 0 1-.047-.639 4.098 4.098 0 0 1 .045-.64c.028-.218.084-.433.166-.639.083.206.139.42.167.64.032.212.047.425.045.64 0 .213-.015.427-.047.639-.028.219-.082.434-.163.64ZM74.381 48.432a.69.69 0 0 1-.166-.27.766.766 0 0 1-.047-.27.754.754 0 0 1 .045-.27.186.186 0 1 1 .333 0 .756.756 0 0 1 .045.27.764.764 0 0 1-.047.27.69.69 0 0 1-.163.27Z"
      />
      <path
        fill="#2961FA"
        d="M73.954 52.281a27.87 27.87 0 0 1-.167-2.193 52.451 52.451 0 0 1 0-4.387c.03-.731.079-1.463.168-2.194.09.732.135 1.463.168 2.194a53.16 53.16 0 0 1 0 4.387 27.86 27.86 0 0 1-.169 2.193Z"
      />
      <path
        fill="#2961FA"
        d="M73.528 53.184a40.383 40.383 0 0 1-.167-2.645 76.235 76.235 0 0 1 0-5.29c.031-.881.079-1.762.168-2.644.09.882.135 1.763.168 2.644a77.493 77.493 0 0 1 0 5.29 40.11 40.11 0 0 1-.169 2.645Z"
      />
      <path
        fill="#2961FA"
        d="M73.1 52.872c-.09-.83-.134-1.66-.166-2.489s-.045-1.659-.045-2.489c0-.829.014-1.658.045-2.488.03-.83.078-1.66.168-2.49.09.83.135 1.66.167 2.49a68.636 68.636 0 0 1 0 4.978c-.03.829-.08 1.659-.168 2.488Z"
      />
      <path
        fill="#2961FA"
        d="M72.675 52.521a30.957 30.957 0 0 1-.167-2.313 58.336 58.336 0 0 1 0-4.627c.03-.77.079-1.542.167-2.313.09.771.136 1.542.168 2.313a59.301 59.301 0 0 1 0 4.627c-.03.77-.08 1.542-.168 2.313Z"
      />
      <path
        fill="#2961FA"
        d="M72.247 53.032a37.989 37.989 0 0 1-.167-2.566 71.814 71.814 0 0 1 0-5.134c.03-.856.079-1.711.168-2.567.09.856.135 1.711.167 2.567a72.754 72.754 0 0 1 0 5.134c-.03.855-.079 1.71-.168 2.566Z"
      />
      <path
        fill="#2961FA"
        d="M71.823 52.64a32.62 32.62 0 0 1-.167-2.373 61.387 61.387 0 0 1 0-4.746c.031-.792.08-1.583.168-2.374.09.791.135 1.582.167 2.373a62.198 62.198 0 0 1 0 4.746 32.55 32.55 0 0 1-.168 2.374Z"
      />
      <path
        fill="#2961FA"
        d="M71.396 52.41a29.49 29.49 0 0 1-.167-2.258 55.55 55.55 0 0 1 0-4.515c.03-.752.078-1.505.167-2.257.09.752.135 1.505.168 2.257a56.468 56.468 0 0 1 0 4.515c-.03.752-.08 1.505-.168 2.257Z"
      />
      <path
        fill="#2961FA"
        d="M70.968 52.082a25.408 25.408 0 0 1-.167-2.094 47.813 47.813 0 0 1 0-4.187c.03-.698.079-1.396.168-2.094.09.698.135 1.396.167 2.094a48.557 48.557 0 0 1 0 4.187 25.47 25.47 0 0 1-.168 2.094Z"
      />
      <path
        fill="#2961FA"
        d="M70.542 51.715a21.188 21.188 0 0 1-.167-1.91 39.784 39.784 0 0 1 0-3.82c.03-.637.079-1.274.168-1.91.09.636.135 1.273.167 1.91a40.314 40.314 0 0 1 0 3.82 21.19 21.19 0 0 1-.168 1.91Z"
      />
      <path
        fill="#2961FA"
        d="M70.114 49.986a6.857 6.857 0 0 1-.167-1.045 11.91 11.91 0 0 1 0-2.091c.029-.353.085-.702.168-1.046.083.344.139.693.167 1.046a12.187 12.187 0 0 1 0 2.09 6.847 6.847 0 0 1-.168 1.047Z"
      />
      <path
        fill="#2961FA"
        d="M69.689 52.377a29.072 29.072 0 0 1-.167-2.241 52.357 52.357 0 0 1-.045-2.242c0-.747.013-1.494.045-2.241.03-.747.078-1.494.167-2.241.09.747.135 1.494.168 2.24a55.462 55.462 0 0 1 0 4.483c-.03.748-.08 1.495-.168 2.242Z"
      />
      <path
        fill="#2961FA"
        d="M69.263 51.97c-.09-.679-.135-1.358-.167-2.037a45.3 45.3 0 0 1 0-4.076c.03-.68.079-1.359.167-2.038.09.68.135 1.359.168 2.038a45.856 45.856 0 0 1 0 4.076c-.03.679-.08 1.358-.168 2.037Z"
      />
      <path
        fill="#2961FA"
        d="M68.836 49.812a5.644 5.644 0 0 1-.165-.959 9.276 9.276 0 0 1-.048-.958c-.002-.32.013-.64.045-.959.028-.324.083-.645.167-.959.083.314.139.635.166.959.063.638.063 1.28 0 1.918a5.638 5.638 0 0 1-.165.958Z"
      />
      <path
        fill="#2961FA"
        d="M68.41 52.316a27.619 27.619 0 0 1-.165-2.21c-.02-.37-.024-.737-.036-1.106l-.012-1.105.011-1.105c.012-.368.016-.737.036-1.105.031-.737.078-1.474.167-2.21.09.736.135 1.473.166 2.21.02.368.024.737.036 1.105l.011 1.105L68.613 49c-.012.369-.016.737-.036 1.105a29.297 29.297 0 0 1-.167 2.21ZM67.983 53.437a43.359 43.359 0 0 1-.166-2.77c-.02-.463-.024-.925-.036-1.387l-.012-1.385.012-1.386c.011-.462.016-.923.035-1.385.031-.924.078-1.847.167-2.771.09.923.135 1.846.167 2.77.02.462.023.924.035 1.386l.011 1.386-.011 1.385c-.012.462-.016.924-.036 1.386a45.712 45.712 0 0 1-.166 2.77ZM67.555 52.843c-.09-.824-.135-1.65-.166-2.474-.02-.412-.024-.824-.035-1.237l-.012-1.237.011-1.237c.012-.412.016-.825.036-1.237.03-.825.077-1.649.166-2.474.09.825.135 1.65.167 2.474.02.413.023.825.035 1.237l.012 1.237-.012 1.237c-.012.413-.016.825-.036 1.237-.032.825-.078 1.65-.166 2.474ZM67.131 50.136a7.63 7.63 0 0 1-.165-1.12 13.283 13.283 0 0 1-.003-2.242c.028-.377.083-.751.167-1.12.084.369.14.743.166 1.12.034.374.045.748.045 1.12 0 .374-.013.748-.047 1.121-.026.377-.08.752-.163 1.12Z"
      />
      <path
        fill="#2961FA"
        d="M66.703 49.7a5.043 5.043 0 0 1-.165-.903 8.303 8.303 0 0 1-.048-.902 8.126 8.126 0 0 1 .045-.903 4.97 4.97 0 0 1 .167-.903c.083.295.14.597.167.903.062.6.062 1.206 0 1.806a5.027 5.027 0 0 1-.166.902Z"
      />
      <path
        fill="#2961FA"
        d="M66.278 53.591c-.09-.95-.136-1.898-.166-2.848-.02-.475-.024-.95-.036-1.424l-.011-1.424.01-1.424c.012-.474.016-.95.036-1.424.031-.949.078-1.899.167-2.848.09.95.135 1.898.166 2.848.02.475.024.95.036 1.424l.011 1.424-.011 1.424c-.012.475-.016.95-.036 1.424-.032.95-.078 1.898-.166 2.848ZM65.85 54.021a52.927 52.927 0 0 1-.166-3.062c-.02-.51-.024-1.021-.036-1.53l-.011-1.532.011-1.531c.012-.51.016-1.021.036-1.531.03-1.022.077-2.042.166-3.062.09 1.021.135 2.042.167 3.062.02.51.023 1.021.035 1.53l.012 1.532-.012 1.531c-.012.51-.016 1.021-.036 1.531a55.748 55.748 0 0 1-.166 3.062ZM65.422 53.765a48.512 48.512 0 0 1-.166-2.936c-.02-.489-.024-.978-.035-1.467l-.012-1.468.011-1.467c.012-.49.016-.979.036-1.468.03-.979.077-1.957.166-2.935.09.978.136 1.956.167 2.935.02.49.023.979.036 1.468l.01 1.467-.01 1.468c-.013.489-.017.978-.036 1.467a51.383 51.383 0 0 1-.167 2.936ZM64.996 49.535a4.197 4.197 0 0 1-.165-.82 6.83 6.83 0 0 1-.048-.82 6.706 6.706 0 0 1 .045-.82 4.14 4.14 0 0 1 .167-.82c.083.267.139.541.167.82.031.272.046.546.045.82 0 .274-.015.548-.048.82a4.18 4.18 0 0 1-.163.82ZM64.57 49.055a2.237 2.237 0 0 1-.165-.58 3.437 3.437 0 0 1-.047-.58 3.374 3.374 0 0 1 .045-.58c.028-.2.084-.395.166-.58.082.185.138.38.167.58.031.192.046.386.045.58 0 .195-.015.389-.047.58a2.23 2.23 0 0 1-.163.58Z"
      />
      <path
        fill="#2961FA"
        d="M64.145 48.687a1.183 1.183 0 0 1-.166-.396 1.623 1.623 0 0 1-.047-.396 1.597 1.597 0 0 1 .045-.396.234.234 0 1 1 .333 0c.031.13.046.262.045.396 0 .133-.015.266-.047.396-.03.141-.085.275-.163.396Z"
      />
      <path
        fill="#2961FA"
        d="M63.719 49.371a3.45 3.45 0 0 1-.166-.738 5.537 5.537 0 0 1-.047-.738 5.452 5.452 0 0 1 .045-.738c.028-.252.084-.5.167-.738.082.239.138.486.166.738.032.245.047.491.045.738.001.247-.015.493-.047.738a3.447 3.447 0 0 1-.163.738Z"
      />
      <path
        fill="#2961FA"
        d="M63.292 53.576a46.492 46.492 0 0 1-.167-2.84 87.963 87.963 0 0 1 0-5.682c.03-.948.078-1.895.168-2.842.09.946.135 1.894.167 2.841a89.422 89.422 0 0 1 0 5.682c-.03.947-.08 1.894-.168 2.841Z"
      />
      <path
        fill="#2961FA"
        d="M62.864 53.072a38.75 38.75 0 0 1-.167-2.59 73.06 73.06 0 0 1 0-5.178c.031-.862.079-1.725.168-2.588.09.863.135 1.726.167 2.59a73.996 73.996 0 0 1 0 5.178c-.03.862-.079 1.725-.168 2.588Z"
      />
      <path
        fill="#2961FA"
        d="M62.439 53.204c-.09-.885-.135-1.77-.167-2.657a76.908 76.908 0 0 1 0-5.314c.03-.886.078-1.77.167-2.656.09.885.135 1.77.168 2.657a77.95 77.95 0 0 1 0 5.314 40.31 40.31 0 0 1-.168 2.656Z"
      />
      <path
        fill="#2961FA"
        d="M62.01 52.864a35.688 35.688 0 0 1-.166-2.485 67.104 67.104 0 0 1 0-4.97c.03-.829.078-1.657.167-2.486.09.829.136 1.657.168 2.486a68.215 68.215 0 0 1 0 4.97c-.03.829-.079 1.657-.168 2.486Z"
      />
      <path
        fill="#2961FA"
        d="M61.585 53.204c-.09-.885-.135-1.77-.167-2.657a76.909 76.909 0 0 1 0-5.314c.03-.886.078-1.77.168-2.656.09.885.135 1.77.167 2.657a77.95 77.95 0 0 1 0 5.314c-.03.887-.08 1.771-.168 2.656Z"
      />
      <path
        fill="#2961FA"
        d="M61.157 51.925a23.591 23.591 0 0 1-.167-2.015 44.277 44.277 0 0 1 0-4.03c.031-.672.08-1.344.168-2.016.09.672.135 1.344.167 2.015a44.858 44.858 0 0 1 0 4.03c-.03.673-.08 1.344-.168 2.016Z"
      />
      <path
        fill="#2961FA"
        d="M60.734 50.18a8.168 8.168 0 0 1-.168-1.143c-.031-.38-.044-.761-.044-1.142 0-.381.014-.762.044-1.143.029-.384.085-.766.168-1.142.083.376.14.758.168 1.142a14.548 14.548 0 0 1 0 2.285 8.17 8.17 0 0 1-.168 1.143Z"
      />
      <path
        fill="#2961FA"
        d="M60.306 51.788a21.994 21.994 0 0 1-.167-1.947 41.32 41.32 0 0 1 0-3.893c.03-.65.079-1.298.167-1.947.09.649.135 1.298.168 1.947a41.867 41.867 0 0 1 0 3.893c-.03.649-.08 1.298-.168 1.947Z"
      />
      <path
        fill="#2961FA"
        d="M59.878 50.036a7.187 7.187 0 0 1-.167-1.071 12.53 12.53 0 0 1 0-2.142c.028-.36.084-.718.168-1.07.083.352.139.71.167 1.07a12.78 12.78 0 0 1 0 2.142c-.029.36-.085.719-.168 1.07Z"
      />
      <path
        fill="#2961FA"
        d="M59.452 50.036a7.174 7.174 0 0 1-.167-1.071 12.489 12.489 0 0 1 0-2.142c.029-.36.085-.718.168-1.07.083.352.139.71.167 1.07a12.78 12.78 0 0 1 0 2.142c-.029.36-.085.719-.168 1.07Z"
      />
      <path
        fill="#2961FA"
        d="M59.027 50.305a9.05 9.05 0 0 1-.168-1.205 15.87 15.87 0 0 1 0-2.411c.029-.405.085-.808.168-1.206.083.398.14.8.167 1.206a16.127 16.127 0 0 1 0 2.41 9.068 9.068 0 0 1-.167 1.206Z"
      />
      <path
        fill="#2961FA"
        d="M58.6 49.96a6.707 6.707 0 0 1-.166-1.035 11.724 11.724 0 0 1 0-2.071c.028-.35.084-.696.167-1.036.083.34.14.687.168 1.036a11.898 11.898 0 0 1 0 2.071c-.03.35-.085.695-.168 1.036Z"
      />
      <path
        fill="#2961FA"
        d="M58.173 52.05a25.02 25.02 0 0 1-.167-2.078 47.068 47.068 0 0 1 0-4.156c.03-.692.079-1.385.167-2.077.09.692.136 1.385.168 2.078a47.683 47.683 0 0 1 0 4.156c-.03.692-.08 1.384-.168 2.077Z"
      />
      <path
        fill="#2961FA"
        d="M57.745 52.465a30.214 30.214 0 0 1-.167-2.286 56.953 56.953 0 0 1 0-4.57c.03-.762.079-1.524.168-2.285.09.761.135 1.523.167 2.285a57.684 57.684 0 0 1 0 4.57c-.03.762-.08 1.524-.168 2.286Z"
      />
      <path
        fill="#2961FA"
        d="M57.322 52.281a27.87 27.87 0 0 1-.168-2.193 52.451 52.451 0 0 1 0-4.387c.031-.731.08-1.463.168-2.194.09.732.135 1.463.167 2.194a53.337 53.337 0 0 1 0 4.387c-.03.731-.08 1.462-.167 2.193Z"
      />
      <path
        fill="#2961FA"
        d="M56.894 51.794c-.09-.65-.135-1.3-.167-1.95a41.47 41.47 0 0 1 0-3.9c.03-.651.078-1.301.168-1.952.09.65.135 1.3.167 1.95a42.165 42.165 0 0 1 0 3.9c-.03.652-.08 1.302-.168 1.952Z"
      />
      <path
        fill="#2961FA"
        d="M56.468 50.314a9.094 9.094 0 0 1-.167-1.21 15.977 15.977 0 0 1 0-2.42c.028-.405.084-.809.168-1.208.083.399.14.803.167 1.21a16.296 16.296 0 0 1 0 2.419 9.13 9.13 0 0 1-.168 1.21Z"
      />
      <path
        fill="#2961FA"
        d="M56.04 50.01a7.003 7.003 0 0 1-.167-1.058 12.188 12.188 0 0 1 0-2.116c.029-.356.085-.71.168-1.057.083.347.139.701.167 1.058a12.476 12.476 0 0 1 0 2.115 6.99 6.99 0 0 1-.168 1.058Z"
      />
      <path
        fill="#2961FA"
        d="M55.612 50.314a9.11 9.11 0 0 1-.167-1.21 15.977 15.977 0 0 1 0-2.42c.029-.405.085-.809.168-1.208.083.399.14.803.168 1.21a16.296 16.296 0 0 1 0 2.419c-.03.406-.085.81-.169 1.21Z"
      />
      <path
        fill="#2961FA"
        d="M55.187 49.507a4.182 4.182 0 0 1-.167-.806 7.035 7.035 0 0 1-.045-.807c-.001-.27.014-.539.045-.806.029-.274.085-.544.167-.807.083.263.139.533.168.806.03.268.046.538.045.807 0 .27-.015.539-.045.807a4.17 4.17 0 0 1-.168.806ZM54.76 48.852a1.65 1.65 0 0 1-.166-.479 2.51 2.51 0 0 1 0-.958c.03-.167.087-.33.167-.48.08.15.137.313.168.48.03.158.046.318.045.48 0 .16-.015.32-.045.478-.031.168-.088.33-.168.48Z"
      />
      <path
        fill="#2961FA"
        d="M54.333 48.422a.704.704 0 0 1-.167-.264.778.778 0 0 1 0-.527.186.186 0 0 1 .079-.24.186.186 0 0 1 .257.24.776.776 0 0 1 0 .527.699.699 0 0 1-.169.264Z"
      />
      <path
        fill="#2961FA"
        d="M53.907 48.454a.754.754 0 0 1-.167-.28.869.869 0 0 1 0-.56.19.19 0 1 1 .336 0 .869.869 0 0 1 0 .56.751.751 0 0 1-.169.28Z"
      />
      <path
        fill="#2961FA"
        d="M53.482 48.615a1.053 1.053 0 0 1-.167-.36 1.426 1.426 0 0 1 0-.72 1.04 1.04 0 0 1 .167-.36c.079.107.136.23.168.36.03.117.045.238.045.36 0 .121-.015.242-.045.36-.033.13-.09.252-.168.36Z"
      />
      <path
        fill="#2961FA"
        d="M53.056 48.615a1.051 1.051 0 0 1-.167-.36 1.426 1.426 0 0 1 0-.72c.032-.13.089-.253.167-.36.079.107.136.23.168.36.03.117.046.238.045.36 0 .121-.015.242-.045.36a1.05 1.05 0 0 1-.168.36Z"
      />
      <path
        fill="#2961FA"
        d="M52.63 48.615a1.051 1.051 0 0 1-.167-.36 1.426 1.426 0 0 1 0-.72c.032-.13.09-.253.167-.36.079.107.136.23.168.36a1.425 1.425 0 0 1 0 .72 1.05 1.05 0 0 1-.168.36Z"
      />
      <path
        fill="#2961FA"
        d="M52.2 48.852a1.65 1.65 0 0 1-.167-.479 2.51 2.51 0 0 1 0-.958c.03-.167.087-.33.168-.48.08.15.137.313.167.48.031.158.046.318.045.48 0 .16-.014.32-.045.478-.03.168-.087.33-.168.48Z"
      />
      <path
        fill="#2961FA"
        d="M51.775 49.092a2.424 2.424 0 0 1-.167-.6 3.899 3.899 0 0 1 0-1.197c.03-.206.086-.407.167-.599.082.192.138.393.168.599.03.198.045.398.045.599 0 .2-.015.4-.045.599-.03.206-.087.407-.168.599Z"
      />
      <path
        fill="#2961FA"
        d="M51.349 49.092a2.424 2.424 0 0 1-.167-.6 3.899 3.899 0 0 1 0-1.197c.03-.206.086-.407.167-.599.082.192.138.393.168.599.03.198.046.398.045.599 0 .2-.015.4-.045.599-.03.206-.087.407-.168.599Z"
      />
      <path
        fill="#2961FA"
        d="M50.921 49.332a3.373 3.373 0 0 1-.167-.72 5.598 5.598 0 0 1-.045-.721c0-.241.014-.482.045-.72.029-.246.085-.488.168-.721.082.233.138.475.167.72.03.24.046.48.045.72 0 .242-.014.482-.045.721-.03.246-.086.488-.168.72Z"
      />
      <path
        fill="#2961FA"
        d="M50.493 50.074a7.453 7.453 0 0 1-.167-1.09 12.976 12.976 0 0 1 0-2.18c.029-.366.085-.73.168-1.09.083.36.139.724.167 1.09a13.236 13.236 0 0 1 0 2.18 7.415 7.415 0 0 1-.168 1.09Z"
      />
      <path
        fill="#2961FA"
        d="M50.07 53.647a47.627 47.627 0 0 1-.167-2.877 89.86 89.86 0 0 1 0-5.752c.03-.959.078-1.917.167-2.876.09.959.135 1.917.167 2.876a91.352 91.352 0 0 1 0 5.752c-.03.96-.078 1.918-.167 2.877Z"
      />
      <path
        fill="#2961FA"
        d="M49.642 53.398a43.74 43.74 0 0 1-.167-2.752 82.574 82.574 0 0 1 0-5.505c.03-.917.078-1.834.167-2.752.09.918.135 1.835.168 2.752a83.934 83.934 0 0 1 0 5.505c-.03.917-.08 1.835-.168 2.752Z"
      />
      <path
        fill="#2961FA"
        d="M49.217 48.623a1.038 1.038 0 0 1-.166-.365 1.378 1.378 0 0 1-.047-.364 1.353 1.353 0 0 1 .045-.364 1.03 1.03 0 0 1 .166-.364c.08.109.136.233.167.364.031.119.047.241.045.364 0 .123-.015.246-.047.364-.03.131-.086.255-.163.365ZM48.791 49.31a3.195 3.195 0 0 1-.165-.708 5.072 5.072 0 0 1-.048-.708 4.997 4.997 0 0 1 .045-.707c.028-.241.084-.479.166-.707.083.228.139.466.167.707.032.234.047.47.045.707 0 .237-.015.473-.047.708a3.186 3.186 0 0 1-.163.707ZM48.363 52.603c-.09-.785-.135-1.57-.165-2.355-.02-.392-.024-.784-.036-1.177l-.012-1.177.012-1.177c.011-.392.015-.785.035-1.177.031-.785.078-1.57.166-2.354.09.785.136 1.57.167 2.354.02.392.023.785.036 1.177l.01 1.177-.01 1.177c-.013.393-.017.785-.036 1.178-.032.784-.078 1.57-.167 2.354ZM47.936 52.204a26.299 26.299 0 0 1-.166-2.155c-.02-.36-.024-.72-.036-1.077l-.011-1.077.01-1.077c.013-.36.017-.718.037-1.077.03-.719.077-1.437.166-2.155.09.718.135 1.436.166 2.155.02.36.024.72.036 1.077l.011 1.077-.012 1.077c-.011.36-.015.718-.035 1.077a27.55 27.55 0 0 1-.166 2.155Z"
      />
      <path
        fill="#2961FA"
        d="M47.509 52.463a30.187 30.187 0 0 1-.167-2.284 56.889 56.889 0 0 1 0-4.569c.03-.762.079-1.523.167-2.285.09.762.136 1.523.168 2.285a57.644 57.644 0 0 1 0 4.569 30.19 30.19 0 0 1-.168 2.284Z"
      />
      <path
        fill="#2961FA"
        d="M47.083 53.303c-.09-.9-.135-1.802-.167-2.702a79.562 79.562 0 0 1 0-5.404c.03-.9.078-1.801.168-2.702.09.9.135 1.801.167 2.702a80.884 80.884 0 0 1 0 5.404c-.03.9-.079 1.801-.168 2.702Z"
      />
      <path
        fill="#2961FA"
        d="M46.655 52.374a29.07 29.07 0 0 1-.167-2.24 54.668 54.668 0 0 1 0-4.479c.031-.746.08-1.492.168-2.239.09.747.135 1.493.167 2.24a55.392 55.392 0 0 1 0 4.479c-.03.746-.08 1.492-.168 2.239Z"
      />
      <path
        fill="#2961FA"
        d="M46.228 50.218a8.427 8.427 0 0 1-.167-1.162 14.693 14.693 0 0 1 0-2.324c.028-.39.084-.779.167-1.161.083.382.14.77.168 1.161a15.035 15.035 0 0 1 0 2.324c-.03.39-.085.779-.168 1.162Z"
      />
      <path
        fill="#2961FA"
        d="M45.804 50.281a8.873 8.873 0 0 1-.167-1.193 15.555 15.555 0 0 1 0-2.387c.028-.401.084-.8.167-1.193.084.393.14.792.168 1.193a15.864 15.864 0 0 1 0 2.387c-.029.401-.085.8-.168 1.193Z"
      />
      <path
        fill="#2961FA"
        d="M45.378 50.03a7.13 7.13 0 0 1-.167-1.068 12.459 12.459 0 0 1 0-2.135c.029-.36.084-.717.168-1.068.083.351.139.708.167 1.068a12.702 12.702 0 0 1 0 2.135c-.029.36-.085.717-.168 1.068Z"
      />
      <path
        fill="#2961FA"
        d="M44.95 51.868a22.899 22.899 0 0 1-.167-1.987 43.039 43.039 0 0 1 0-3.974 22.9 22.9 0 0 1 .168-1.987c.09.663.135 1.325.167 1.987a43.609 43.609 0 0 1 0 3.974c-.03.662-.08 1.325-.168 1.987Z"
      />
      <path
        fill="#2961FA"
        d="M44.525 53.41c-.09-.92-.136-1.838-.167-2.758a82.859 82.859 0 0 1 0-5.516c.03-.919.078-1.838.167-2.758.09.92.135 1.839.168 2.758a84.31 84.31 0 0 1 0 5.516c-.03.92-.08 1.839-.168 2.758Z"
      />
      <path
        fill="#2961FA"
        d="M44.099 53.224a41.013 41.013 0 0 1-.167-2.665 77.153 77.153 0 0 1 0-5.33c.03-.888.078-1.776.167-2.664.09.888.135 1.776.168 2.664a78.43 78.43 0 0 1 0 5.33c-.03.889-.079 1.78-.168 2.665Z"
      />
      <path
        fill="#2961FA"
        d="M43.671 53.081a38.835 38.835 0 0 1-.167-2.593 73.304 73.304 0 0 1 0-5.187c.03-.864.078-1.729.167-2.593.09.864.136 1.729.168 2.593a74.521 74.521 0 0 1 0 5.187 38.29 38.29 0 0 1-.168 2.593Z"
      />
      <path
        fill="#2961FA"
        d="M43.244 48.345a.576.576 0 0 1-.165-.225.553.553 0 0 1-.048-.225.545.545 0 0 1 .045-.225.175.175 0 1 1 .333 0c.031.07.046.148.045.225a.553.553 0 0 1-.047.225.575.575 0 0 1-.163.225Z"
      />
      <path
        fill="#2961FA"
        d="M42.82 53.242a41.256 41.256 0 0 1-.167-2.674 77.696 77.696 0 0 1 0-5.348c.03-.892.078-1.783.167-2.674.09.89.135 1.782.167 2.674a78.96 78.96 0 0 1 0 5.348c-.03.89-.078 1.782-.167 2.674Z"
      />
      <path
        fill="#2961FA"
        d="M42.393 50.117a7.505 7.505 0 0 1-.166-1.111 13.099 13.099 0 0 1-.002-2.222 7.41 7.41 0 0 1 .166-1.111c.084.365.14.737.167 1.11.034.37.045.742.045 1.112 0 .37-.014.74-.047 1.11a7.49 7.49 0 0 1-.163 1.112Z"
      />
      <path
        fill="#2961FA"
        d="M41.965 49.242a2.921 2.921 0 0 1-.166-.675 4.613 4.613 0 0 1-.047-.676 4.542 4.542 0 0 1 .045-.675c.028-.231.084-.458.166-.676.083.218.139.445.167.676.032.224.047.45.045.675 0 .226-.015.452-.047.676-.027.23-.082.457-.163.675ZM41.54 48.594a.978.978 0 0 1-.166-.35 1.269 1.269 0 0 1-.048-.35 1.254 1.254 0 0 1 .045-.35.973.973 0 0 1 .166-.35.97.97 0 0 1 .167.35c.032.114.047.232.045.35 0 .118-.015.236-.047.35a.979.979 0 0 1-.163.35Z"
      />
      <path
        fill="#2961FA"
        d="M41.112 53.466a44.767 44.767 0 0 1-.167-2.786 84.592 84.592 0 0 1 0-5.572 44.5 44.5 0 0 1 .168-2.786c.09.928.135 1.857.168 2.786a86.006 86.006 0 0 1 0 5.572 44.11 44.11 0 0 1-.169 2.786Z"
      />
      <path
        fill="#2961FA"
        d="M40.685 52.71a33.516 33.516 0 0 1-.167-2.408 63.212 63.212 0 0 1 0-4.815c.03-.803.078-1.606.167-2.408.09.802.135 1.605.168 2.408a63.988 63.988 0 0 1 0 4.815c-.03.802-.08 1.605-.168 2.408Z"
      />
      <path
        fill="#2961FA"
        d="M40.259 53.183a40.365 40.365 0 0 1-.167-2.645 76.202 76.202 0 0 1 0-5.288c.03-.881.078-1.763.167-2.644.09.881.136 1.763.168 2.644a77.217 77.217 0 0 1 0 5.288c-.03.882-.079 1.764-.168 2.645Z"
      />
      <path
        fill="#2961FA"
        d="M39.833 52.242a27.36 27.36 0 0 1-.167-2.173 51.506 51.506 0 0 1 0-4.347c.03-.725.079-1.45.168-2.174.09.724.135 1.449.167 2.173a52.36 52.36 0 0 1 0 4.347c-.03.725-.08 1.45-.168 2.174Z"
      />
      <path
        fill="#2961FA"
        d="M39.407 49.81a5.798 5.798 0 0 1-.167-.958 10.022 10.022 0 0 1 0-1.915c.029-.323.085-.643.168-.957.083.314.139.634.167.957a10.222 10.222 0 0 1 0 1.915 5.777 5.777 0 0 1-.168.958Z"
      />
      <path
        fill="#2961FA"
        d="M38.98 48.852a1.65 1.65 0 0 1-.167-.479 2.51 2.51 0 0 1 0-.958c.03-.167.087-.33.167-.48.08.15.137.313.168.48.03.158.045.318.045.48 0 .16-.015.32-.045.478-.031.168-.088.33-.168.48Z"
      />
      <path
        fill="#2961FA"
        d="M38.554 49.332a3.373 3.373 0 0 1-.167-.72 5.598 5.598 0 0 1-.045-.721c-.001-.241.014-.482.045-.72.029-.246.085-.488.167-.721.083.233.139.475.168.72.03.24.046.48.045.72 0 .242-.015.482-.045.721-.03.246-.086.488-.168.72ZM38.126 49.332a3.374 3.374 0 0 1-.167-.72 5.598 5.598 0 0 1-.045-.721c0-.241.014-.482.045-.72.03-.246.085-.488.168-.721.082.233.138.475.167.72.031.24.046.48.045.72 0 .242-.014.482-.045.721-.03.246-.085.488-.168.72Z"
      />
      <path
        fill="#2961FA"
        d="M37.7 52.242a27.36 27.36 0 0 1-.167-2.173 51.506 51.506 0 0 1 0-4.347c.03-.725.08-1.45.168-2.174.09.724.135 1.449.167 2.173a52.36 52.36 0 0 1 0 4.347c-.03.725-.08 1.45-.168 2.174Z"
      />
      <path
        fill="#2961FA"
        d="M37.275 52.729a33.756 33.756 0 0 1-.167-2.417 63.651 63.651 0 0 1 0-4.834c.03-.806.078-1.612.167-2.418.09.806.135 1.611.168 2.418a64.76 64.76 0 0 1 0 4.834c-.03.806-.08 1.611-.168 2.417Z"
      />
      <path
        fill="#2961FA"
        d="M36.847 52.058a25.09 25.09 0 0 1-.167-2.082 47.234 47.234 0 0 1 0-4.163c.03-.693.079-1.387.167-2.08.09.693.135 1.387.168 2.08a47.86 47.86 0 0 1 0 4.163c-.03.694-.08 1.388-.168 2.082Z"
      />
      <path
        fill="#2961FA"
        d="M36.42 53.524a45.682 45.682 0 0 1-.168-2.814 86 86 0 0 1 0-5.629c.03-.938.078-1.876.168-2.814.09.938.135 1.876.167 2.814a87.495 87.495 0 0 1 0 5.629 44.97 44.97 0 0 1-.168 2.814Z"
      />
      <path
        fill="#2961FA"
        d="M35.995 52.808a34.9 34.9 0 0 1-.167-2.456 65.78 65.78 0 0 1 0-4.914c.03-.819.079-1.639.168-2.457.09.819.135 1.637.167 2.457a66.87 66.87 0 0 1 0 4.914 34.37 34.37 0 0 1-.168 2.456Z"
      />
      <path
        fill="#2961FA"
        d="M35.568 52.242a27.36 27.36 0 0 1-.167-2.173 51.506 51.506 0 0 1 0-4.347c.03-.725.078-1.45.167-2.174.09.724.135 1.449.168 2.173a52.187 52.187 0 0 1 0 4.347c-.03.725-.08 1.45-.168 2.174Z"
      />
      <path
        fill="#2961FA"
        d="M35.14 51.627a20.243 20.243 0 0 1-.167-1.866 37.837 37.837 0 0 1 0-3.733c.03-.622.079-1.244.167-1.866.09.622.135 1.244.168 1.866a38.511 38.511 0 0 1 0 3.733c-.03.622-.08 1.244-.168 1.866Z"
      />
      <path
        fill="#2961FA"
        d="M34.714 52.058a25.09 25.09 0 0 1-.167-2.082 47.234 47.234 0 0 1 0-4.163c.03-.693.079-1.387.167-2.08.09.693.136 1.387.168 2.08a47.86 47.86 0 0 1 0 4.163c-.03.694-.08 1.388-.168 2.082Z"
      />
      <path
        fill="#2961FA"
        d="M34.288 50.175a8.129 8.129 0 0 1-.167-1.14 14.188 14.188 0 0 1 0-2.28 8.01 8.01 0 0 1 .168-1.14c.083.376.139.757.167 1.14a14.428 14.428 0 0 1 0 2.28 8.1 8.1 0 0 1-.168 1.14Z"
      />
      <path
        fill="#2961FA"
        d="M33.862 49.768a5.548 5.548 0 0 1-.166-.937 9.445 9.445 0 0 1-.046-.937c0-.313.015-.626.046-.937.028-.317.084-.63.167-.938.083.308.139.621.168.938a9.734 9.734 0 0 1 0 1.874c-.03.317-.086.63-.169.937ZM33.435 49.373a3.555 3.555 0 0 1-.167-.74 5.934 5.934 0 0 1 0-1.479c.029-.251.085-.5.167-.739.083.24.139.488.168.74.03.245.045.492.045.739s-.015.494-.045.74c-.03.251-.086.499-.168.739Z"
      />
      <path
        fill="#2961FA"
        d="M33.007 48.852a1.65 1.65 0 0 1-.167-.479 2.51 2.51 0 0 1 0-.958c.03-.167.087-.33.167-.48.081.15.138.313.168.48.03.158.046.318.045.48 0 .16-.015.32-.045.478-.03.168-.087.33-.168.48Z"
      />
      <path
        fill="#2961FA"
        d="M32.581 48.505a.84.84 0 0 1-.167-.306 1.029 1.029 0 0 1-.045-.305c0-.103.015-.206.045-.305a.834.834 0 0 1 .168-.306.834.834 0 0 1 .167.306 1.036 1.036 0 0 1 0 .61.84.84 0 0 1-.168.306Z"
      />
      <path
        fill="#2961FA"
        d="M32.154 48.457a.758.758 0 0 1-.168-.281.882.882 0 0 1 0-.563.75.75 0 0 1 .168-.282c.076.08.133.177.167.282a.882.882 0 0 1 0 .563.757.757 0 0 1-.167.281Z"
      />
      <path
        fill="#2961FA"
        d="M31.73 49.116a2.513 2.513 0 0 1-.167-.61 4.053 4.053 0 0 1-.045-.611c-.001-.205.014-.409.045-.61.03-.21.085-.416.167-.611.082.195.138.4.168.61.03.202.045.406.045.61 0 .205-.015.41-.045.611-.03.21-.087.415-.168.611Z"
      />
      <path
        fill="#2961FA"
        d="M31.302 48.481a.798.798 0 0 1-.167-.293.953.953 0 0 1 0-.587.79.79 0 0 1 .167-.293.79.79 0 0 1 .168.294.959.959 0 0 1 0 .587.797.797 0 0 1-.168.292Z"
      />
      <path
        fill="#2961FA"
        d="M30.876 48.457a.76.76 0 0 1-.167-.281.88.88 0 0 1 0-.563.753.753 0 0 1 .168-.282.75.75 0 0 1 .167.282.882.882 0 0 1 0 .563.755.755 0 0 1-.168.281Z"
      />
      <path
        fill="#2D2756"
        d="M83.21 50.146a2.251 2.251 0 1 0 0-4.503 2.251 2.251 0 0 0 0 4.503Z"
      />
      <rect
        width={1.801}
        height={29.721}
        x={43.533}
        y={35.213}
        fill="#D6D5D5"
        rx={0.901}
        transform="rotate(90 43.533 35.213)"
      />
      <rect
        width={1.801}
        height={29.721}
        x={39.482}
        y={60.881}
        fill="#D6D5D5"
        rx={0.901}
        transform="rotate(90 39.482 60.881)"
      />
    </g>
  </svg>
);

export default EmptyVoiceMsg;
